import * as React from 'react';
import * as textStyles from '../styles/text.module.css';

const MainSubtitle = ({ text, style }) => (
  <h1 className={textStyles.mainSubtitleFont} style={style}>{text}</h1>
);

export default MainSubtitle;
